import { SetStateAction, useState } from "react";
import EstablishmentInterfaceCreate from "./EstablishmentInterfaceCreate";
import EstablishmentInterfaceEdit from "./EstablishmentInterfaceEdit";
import EstablishmentNodeView from "../establishmentNode/EstablishmentNodeView";

const EstablishmentInterfaceIndex = ({
  index,
  isActive,
  mode,
  nextButtonFunction,
  toggleEdit,
  establishmentID,
  closeWizard,
  updateInterfaceData,
  interfaceData
}: EstablishmentInterfaceIndexProps) => {

  const [isEstablishmentInterfaceInit, setIsEstablishmentInterfaceInit] = useState(mode === "edit" ? true : false);
  
  return (
    <>
      {mode === "create" && isActive &&
        <EstablishmentInterfaceCreate
        nextButtonFunction={nextButtonFunction}
        setIsEstablishmentInterfaceInit={setIsEstablishmentInterfaceInit}
        updateInterfaceData={updateInterfaceData} 
        closeWizard={closeWizard}        />
      }

      {mode === "edit" && isActive && 
        <EstablishmentInterfaceEdit 
        nextButtonFunction={nextButtonFunction}
        establishmentID={establishmentID}
        interfaceData={interfaceData} 
        setIsEstablishmentInterfaceInit={setIsEstablishmentInterfaceInit} 
        updateInterfaceData={updateInterfaceData}        />
      } 

      {isEstablishmentInterfaceInit && !isActive &&
        <EstablishmentNodeView 
        toggleEdit={toggleEdit}
        userID={establishmentID}
        closeWizard={closeWizard} 
        interfaceData={interfaceData}        
        />
      }  
    </>
  )
}

export default EstablishmentInterfaceIndex;

type EstablishmentInterfaceIndexProps = {
  isActive: boolean;
  nextButtonFunction: () => void;
  index: number;
  toggleEdit: () => void;
  mode: "create" | "edit";
  establishmentID?: number;
  closeWizard: () => void;
  updateInterfaceData: (data: Partial<IEstablishmentInterfaceForm>) => void;
  interfaceData: IEstablishmentInterfaceForm
}